module.exports = __webpack_public_path__ + "img/trash-regular.cb41977f.svg";